import { connect } from 'react-redux';

import Balances from '../../../components/header/Balances';

import {
  triggerUpdateRightSidebar
} from '../../../modules/rightSidebar/actions';

import { depositRequest } from '@xanadu/ui-shared/modules/user/actions';

import {
  requestNetDepositLimit,
} from '@xanadu/ui-shared/modules/depositLimits/actions';

import {
  displayModal,
} from '@xanadu/ui-shared/modules/modal/actions';

const mapDispatchToProps = {
  depositRequest,
  displayModal,
  requestNetDepositLimit,
  updateRightSidebar: triggerUpdateRightSidebar,
};

function mapStateToProps(state) {
  return {
    balance: state.getIn(['user', 'balance']),
    balanceLoading: state.getIn(['user', 'balanceLoading']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    username: state.getIn(['user', 'username'], ''),
    edgeStatus: state.getIn(['application', 'edgeStatus']),
    widthSize: state.getIn(['application', 'widthSize']),
    rightSidebarContent: state.getIn(['rightSidebar', 'content']),
    casinoPromotions: state.getIn(['promotions', 'main', 'casinoPromotions']),
    userAffordabilityInfoProvided: state.getIn(['user', 'affordabilityInfoProvided']),
    userSegmentCategory: state.getIn(['user', 'segmentCategory']),
    loadingNetDeposit: state.getIn(['depositLimits', 'loadingNetDeposit']),
    netDepositError: state.getIn(['depositLimits', 'error']),
    netDepositLimit: state.getIn(['depositLimits', 'netMonthlyDeposit']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Balances);
